import React, { useState } from "react"
import CustomButton from "../../components/custom-button/custom-button.component"
import { Grid } from "@mui/material"
import parse from "html-react-parser"

import * as S from "./receive-donations.styles"
import FormPopup from "../../components/form-popup/form-popup.component"

const ReceiveDonations = ({ image, bannerInfo }) => {
  return (
    <S.Section>
      <S.Wrapper maxWidth="xl">
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <S.Image img={image} />
          </Grid>
          <Grid item xs={12} md={6}>
            <S.InfoWrapper>
              <S.InfoContainer>
                <S.Pattern img={bannerInfo?.bgPattern} />
                <S.ContentContainer>
                  {/* <S.Logo img={bannerInfo?.icon} /> */}
                  <S.Title>{parse(bannerInfo?.title)}</S.Title>
                  <S.Description>{bannerInfo?.description}</S.Description>
                  <S.ButtonContainer>
                    <CustomButton
                      href={bannerInfo?.button?.url}
                      className="linearGradient"
                      target="_blank"
                    >
                      {bannerInfo?.button?.title}
                    </CustomButton>
                  </S.ButtonContainer>
                </S.ContentContainer>
              </S.InfoContainer>
            </S.InfoWrapper>
          </Grid>
        </Grid>
      </S.Wrapper>
    </S.Section>
  )
}

export default ReceiveDonations
